import { render, staticRenderFns } from "./otherfooter.vue?vue&type=template&id=5888d363&scoped=true&"
import script from "./otherfooter.vue?vue&type=script&lang=js&"
export * from "./otherfooter.vue?vue&type=script&lang=js&"
import style0 from "./otherfooter.vue?vue&type=style&index=0&id=5888d363&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5888d363",
  null
  
)

export default component.exports